import Home from './home.tsx';

export default Home;